import {Row, Col, Card, Table, Button, Input, Tooltip, Image, Switch} from "antd";
import { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import ShowTotal from "../../components/ShowTotal";
import ConfirmationBox from "../../components/ConfirmationBox";
import apiPath from "../../constants/apiPath";
import moment from 'moment';
import { formatDate } from "../../helper/DateHelper";
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from "react-router-dom";
import { getSortOrder } from "../../constants/conts";
const Search = Input.Search;
function Index() {

  const sectionName   =   "CMS";
  const routeName     =   "cms";

  const api = {
    status    :   apiPath.statusCms,
    addEdit   :   apiPath.addEditCms,
    list      :   apiPath.listCms
  }
  
  const location        =   useLocation();
  const navigate        =   useNavigate();
  
  const query           =   new URLSearchParams(location.search);
  const initialPage     =   parseInt(query.get("page")) || 1;
  const initialPageSize =   parseInt(query.get("pageSize")) || 20;
  const initialSearch   =   query.get("search") || "";
  const initialSort     =   query.get("sort") || "";

  const [pagination, setPagination] = useState({
    current: initialPage,
    pageSize: initialPageSize,
  });
  
  const [searchText, setSearchText]   =   useState(initialSearch);
  const [sortBy, setSortBy]           =   useState(initialSort);

  const { request }                   =   useRequest()
  const [list, setList]               =   useState([])
  const { showConfirm }               =   ConfirmationBox()
  const [loading, setLoading]         =   useState(false)
  const [refresh, setRefresh]         =   useState(false)
  const [filters, setFilters]         =   useState({});
  const debouncedSearchText           =   useDebounce(searchText, 500);

  const columns = [
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    sorter: true,
    sortOrder: getSortOrder(sortBy, "title"),
    render: (title) => (
      <div className="cap font-medium">
        {title || "-"}
      </div>
    ),
  },
    {
      title: "Status",
      key: "is_active",
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'Inactive',
          value: false,
        },
      ],
      render: (_, { is_active, _id }) => {
        return (
          <Switch
            checked = {is_active}
            checkedChildren = {<CheckOutlined />}
            unCheckedChildren = {<CloseOutlined />}
            loading = {loading}
            onChange = {(checked) =>
              showConfirm({
                record    : _id,
                path      : api.status,
                onLoading : () => setLoading(true),
                onSuccess : () => setRefresh((prev) => !prev),
                is_active : checked,
              })
            }
            className={is_active ? "custom-switch-checked" : ""}
          />
        );
      },
    },
    {
      title: "Created On",
      key: "created_at",
      dataIndex: "created_at",
      sorter: true,
      sortOrder: getSortOrder(sortBy, "created_at"),
      render: (_, { created_at }) => {
        return (
          formatDate(created_at)
        );
      },
    },
    {
      title: "Action",
      fixed: 'right',
      render: (_, record) => {
        return (
          <>

            <Tooltip title={"Update " + sectionName} color={"purple"} key={"update"}>
              <Button onClick={() => { edit(record._id) }}>
                <i className="fa fa-light fa-pen"></i>
              </Button>
            </Tooltip>
          </>
        );
      },
    },
  ];
  
  const edit = (id) => {
    navigate(`/${routeName}/add-edit/${id}${location.search}`);
  };

  useEffect(() => {
    const params = new URLSearchParams();

    if (pagination.current > 1) params.set("page", pagination.current);
    if (pagination.pageSize !== 20) params.set("pageSize", pagination.pageSize);
    if (debouncedSearchText) params.set("search", debouncedSearchText);
    if (sortBy) params.set("sort", sortBy);

    navigate({ search: params.toString() }, { replace: true });
  }, [pagination.current, pagination.pageSize, debouncedSearchText, sortBy, navigate]);
  
  const fetchData = (pagination, filters, sortValue = '') => {
    const filterActive = filters ? filters.is_active : null
    request({
      url:
        api.list +
        `?status=${filterActive ? filterActive.join(',') : ''}` +
        `&page=${pagination.current}` +
        `&limit=${pagination.pageSize}` +
        `&search=${debouncedSearchText}` +
        `&sort=${sortValue || ''}`,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false)
        setList(data.data.list.docs)
        setPagination(prev => ({
          ...prev,
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: data.data.list.totalDocs
        }));
      },
      onError: (error) => {
        console.log(error)
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  const handleChange = (pag, newFilters, sorter) => {
    const { order, field } = sorter || {};

    let nextSort = '';
    if (order) {
      nextSort = `${field}:${order === 'ascend' ? 'asc' : 'desc'}`;
    }

    setFilters(newFilters || {});

    setSortBy(nextSort);

    setPagination(prev => ({
      ...prev,
      current: pag?.current || 1,
      pageSize: pag?.pageSize || prev.pageSize,
    }));
  };

  const onSearch = (e) => {
    setSearchText(e.target.value)
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  useEffect(() => {
    setLoading(true)
    fetchData(pagination, filters, sortBy)
  }, [refresh, debouncedSearchText, sortBy, pagination.current, pagination.pageSize, filters])

  const handleAddNew = () => {
    navigate(`/${routeName}/add-edit${location.search}`);
  }

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={sectionName + " Management"}
              extra={
                <>
                  <Search
                    size="large"
                    onChange={onSearch}
                    value={searchText}
                    onPressEnter={onSearch}
                    placeholder="Search By Title"
                    style={{ minWidth: 280 }}
                  />

                  {/* <Button onClick={(e) => handleAddNew()}>Add New {sectionName}</Button> */}
                </>
              }
            >
              
              <h4 className="text-right mb-1">{pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}</h4>
              
              <div className="table-responsive customPagination">
                <Table
                  rowKey={(record) => record._id}
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    responsive: true,
                    defaultPageSize: 20,
                    pageSizeOptions: ['10', '20', '30', '50', '100']
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Index;
